module.exports = __webpack_public_path__ + "static/frames-1f807e5a970e3d9c68a438fb2b9458ff.png";